<template>
  <Landing v-if="curr_route && data.name" :data="data" :scrollDown="toTop" />
  <Nav v-if="curr_route && data.name" :data="data" />
  <main id="home">
    <router-view v-slot="{ Component }">
      <transition name="routes-animation" mode="out-in">
        <component :is="Component"></component>
      </transition>
    </router-view>
  </main>
  <Footer v-if="curr_route && data.name" :data="data" />
  <span v-if="curr_route && data.name" class="to-up hide" @click="toTop">
    <i class="arrow alternate up icon" />
  </span>
</template>
<script>
import getData from "./composables/getData";
import router from "./router";
import { onBeforeUpdate, ref } from "vue";
import { Landing } from "./components";
import { Nav, Footer } from "./components";
export default {
  components: { Landing, Nav, Footer },
  setup() {
    const curr_route = ref(true);
    const toTop = () => {
      const sticky = document.querySelector("nav").offsetTop;
      document.body.scrollTop = sticky - 1; // For Safari
      document.documentElement.scrollTop = sticky - 1;
    };
    const { data, error, fetchData } = getData(process.env.VUE_APP_PROFILE);
    fetchData();
    onBeforeUpdate(() => {
      curr_route.value =
        router.currentRoute._value.name !== "not-found" ? true : false;
    });
    return {
      curr_route,
      data,
      error,
      fetchData,
      toTop,
    };
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Space+Mono&display=swap");
:root {
  --primary: #42b983;
  --secondary: #e6e6e6;
  --light: #fafafa;
  --dark: #151515;
  --blue: #2b98ca;
  --yellow: #f9b339;
  --red: #e63946;
  --grey: #6e6e6e;
  --transparent: #000000a8;
  --gradient: linear-gradient(60deg, var(--primary) 5%, #05668d);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Space Mono", monospace, Arial, Helvetica, sans-serif;
}
*:not(#skills *, i.icon.arrow) {
  transition: all ease-in-out 0.9s;
  -webkit-transition: all ease-in-out 0.9s;
}
html {
  scroll-behavior: smooth;
}
#app {
  overflow: hidden;
  position: relative;
  background: #e9e9e9;
}
.box {
  background: #fff;
}
.sticky + main {
  padding-top: 60px;
}
section,
footer {
  width: 100%;
}
.section {
  max-width: 960px;
  margin: 0 auto;
  padding: 3rem 0;
}
.error {
  background: #f3555545;
  border-radius: 5px;
  padding: 2rem;
  margin: 0 auto;
}
h1 {
  font-size: 2.5rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 3rem;
}
h2 {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}
p {
  margin: 1.5rem 0;
}
p,
h2 {
  text-align: left;
  font-weight: 400;
}
a {
  text-decoration: none;
  color: var(--blue);
}
a:hover {
  color: var(--primary);
}
img {
  width: 100%;
}
ul {
  list-style: none;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-col {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}
.grid {
  display: grid;
  grid-gap: 1rem;
}
.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}
.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}
i.icon.linkedin:hover {
  color: #0e76a8;
  border-color: #0e76a8;
}
i.icon.github:hover {
  color: #3f3f3f;
  border-color: #3f3f3f;
}
i.icon.telegram:hover {
  color: #0088cc;
  border-color: #0088cc;
}
i.icon.instagram:hover {
  color: #f76e69;
  border-color: #f76e69;
}
button:not(.read-more):focus {
  outline: none;
  cursor: pointer;
  background: #42b983d1;
}
.btn {
  margin: 0 auto;
  border-radius: 5px;
}
.btn-link {
  border: none;
  background: none;
  cursor: pointer;
}
.btn-link:hover {
  color: var(--blue);
}
.btn-primary {
  padding: 0.8rem 1.1rem;
  vertical-align: middle;
  color: var(--dark);
  font-weight: 600;
  border-radius: 50px;
  border: 1px solid var(--primary);
  background: var(--primary);
}
.btn-primary:hover {
  cursor: pointer;
  background: none;
  border: 1px solid var(--primary);
  color: var(--primary);
}
button.read-more {
  outline: none;
  font-weight: bold;
  color: var(--dark);
}
.clear::after {
  content: "";
  clear: both;
}
/* icons */
i.icon {
  margin: 0;
  padding: 0;
}
i.icon.html5 {
  color: #ff5733;
}
i.icon.css3 {
  color: #264de4;
}
i.icon.js {
  color: #f7df1e;
}
i.icon.react {
  color: #00d8ff;
}
i.icon.vuejs {
  color: #35495e;
}
i.icon.git {
  /* color: #6cc644; */
  color: #4078c0;
}
i.icon.python {
  color: #ffde57;
}
i.icon.database {
  color: #008bb9;
}
i.icon.bimobject {
  color: #563d7c;
}
/* Up botton */
#app .to-up {
  right: 0;
  bottom: 10px;
  z-index: 2;
  width: 56px;
  height: 56px;
  border: none;
  text-align: center;
  line-height: 56px;
  background: var(--primary);
}
#app .fix {
  position: fixed;
}
#app .to-up:hover {
  background: var(--transparent);
}
#app .to-up:hover i.icon.up {
  color: var(--primary);
}
#app .to-up .icon.arrow {
  margin: 0;
  font-size: 17px;
  color: black;
}
/* Animation */
#app .routes-animation-enter-from {
  opacity: 0;
  transform: translateX(-5rem);
}
#app .routes-animation-enter-active {
  transition: all 0.5s ease-out;
}
#app .routes-animation-leave-to {
  opacity: 0;
  transform: translateX(5rem);
}
#app .routes-animation-leave-active {
  transition: all 0.5s ease-in;
}
@media screen and (max-width: 960px) {
  .section {
    width: 80%;
  }
}
@media screen and (max-width: 959px) and (min-width: 590px) {
  .section {
    width: 90%;
  }
  .grid.grid-3 {
    grid-template-columns: 1fr 1fr;
  }
  #skills .grid.grid-3,
  footer .grid.grid-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 589px) {
  .section {
    width: 85%;
  }
  .grid.grid-3 {
    grid-template-columns: 1fr;
  }
  #skills .grid.grid-3 {
    grid-template-columns: 1fr 1fr;
  }
  h1 {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  footer .flex {
    flex-direction: column;
  }
  footer p {
    text-align: center;
  }
  footer .grid {
    margin-bottom: 1rem;
  }
}
</style>
